import { io } from "socket.io-client";

// 펫 단위 publisher — 제어판(producer) → 게이트웨이 pub(/pub/event-stream/virtupet).
//  유저:펫 = 1:N 이라 "Global"(유저)이 아니라 **펫 스코프**. init(petId)로 제어할 펫 등록 → 게이트웨이가
//  같은 petId의 sub 구독자들에게 fan-out. (sub = domain/stream/sub/*Source, 신원은 Edge signaling)
export default class VirtupetPubSocket {
  constructor(petId) {
    if (!petId) throw new Error("E_PET_ID_REQUIRED");
    this.petId = petId;
    this.socket = io(`${process.env.VUE_APP_GATEWAY_HOST_URL}/pub/event-stream/virtupet`, {
      transports: ["websocket"],
    });
    // 제어할 펫 등록 (네임스페이스 pub가 곧 역할 → role 불필요). connect 전 emit은 socket.io가 버퍼링.
    this.socket.emit("command", { method: "init", body: { petId } });
  }

  requestCommand(payload) {
    this.socket.emit("requestCommand", payload);
  }

  requestUpdateVisibility(targetEl, isVisible, userInput) {
    this.requestCommand({ method: "updateVisibility", to: "liveModel", body: { targetEl, isVisible, userInput } });
  }

  // 배경 파일 변경(+가시성)을 라이브 반영. 오버레이 BroadcastBox가 changeBackgroundCanvas로 즉시 교체.
  requestUpdateBackground(fileName, isVisible = true) {
    this.requestCommand({ method: "updateBackground", to: "liveModel", body: { fileName, isVisible } });
  }

  // 모델 좌우반전을 라이브 반영. 오버레이 BroadcastBox가 changeModelReverse로 즉시 적용.
  requestUpdateModelReverse(isReverse) {
    this.requestCommand({ method: "updateModelReverse", to: "liveModel", body: { isReverse } });
  }

  // 레벨·경험치 바 색상을 라이브 반영. 오버레이 BroadcastBox가 ExpBar에 즉시 적용.
  requestUpdateExpColor(color) {
    this.requestCommand({ method: "updateExpColor", to: "liveModel", body: { color } });
  }

  // 파워 이펙트 on/off + 스타일을 라이브 반영. 오버레이 BroadcastBox가 모델 뒤 파티클 레이어에 적용.
  requestUpdateEffect(enabled, style) {
    this.requestCommand({ method: "updateEffect", to: "liveModel", body: { enabled, style } });
  }

  // 오디오 뮤트를 라이브 반영. 오버레이 BroadcastBox가 AudioPlayer 전역 뮤트에 적용.
  requestUpdateMute(muted) {
    this.requestCommand({ method: "updateMute", to: "liveModel", body: { muted } });
  }

  on(event, handler) {
    this.socket.on(event, handler);
    return this;
  }

  close() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

// 펫 단위 공유 인스턴스: 같은 petId면 동일 인스턴스(제어판 컴포넌트들이 소켓 1개 공유), 다른 펫은 별도.
//  싱글톤 아님 — 펫마다 1개. (펫 전환이 잦아지면 이전 인스턴스 close 로직 추가 고려)
const _byPet = new Map();
export function getVirtupetPubSocket(petId) {
  if (!petId) throw new Error("E_PET_ID_REQUIRED");
  if (!_byPet.has(petId)) _byPet.set(petId, new VirtupetPubSocket(petId));
  return _byPet.get(petId);
}
